import { NotificationActionConst } from "../Constants/NotificationConstants";
import { BASE_URL, API_ENDPOINTS } from "../../config/api.config";
import { apiFetch, getAuthHeaders } from "../../utils/apiHelper";

export const fetchNotifications = (page = 1, limit = 20) => {
  return async (dispatch) => {
    dispatch({ type: NotificationActionConst.FETCH_NOTIFICATIONS_REQUEST });
    try {
      const response = await apiFetch(
        `${BASE_URL}${API_ENDPOINTS.NOTIFICATIONS}?page=${page}&limit=${limit}`,
        { headers: getAuthHeaders() },
        dispatch
      );
      const result = await response.json();
      dispatch({
        type: NotificationActionConst.FETCH_NOTIFICATIONS_SUCCESS,
        result: result.data,
      });
    } catch (error) {
      dispatch({
        type: NotificationActionConst.FETCH_NOTIFICATIONS_FAIL,
        error: error.message,
      });
    }
  };
};

export const fetchUnreadCount = () => {
  return async (dispatch) => {
    try {
      const response = await apiFetch(
        `${BASE_URL}${API_ENDPOINTS.NOTIFICATIONS_UNREAD_COUNT}`,
        { headers: getAuthHeaders() },
        dispatch
      );
      const result = await response.json();
      dispatch({
        type: NotificationActionConst.FETCH_UNREAD_COUNT_SUCCESS,
        count: result.data.count,
      });
    } catch (error) {
      console.error("Failed to fetch unread count:", error);
    }
  };
};

export const markNotificationsRead = (notificationIds = [], all = false) => {
  return async (dispatch) => {
    // Optimistically update the UI immediately
    dispatch({ type: NotificationActionConst.MARK_READ_SUCCESS, notificationIds, all });
    try {
      await apiFetch(
        `${BASE_URL}${API_ENDPOINTS.NOTIFICATIONS_MARK_READ}`,
        {
          method: "POST",
          headers: getAuthHeaders(),
          body: JSON.stringify(all ? { all: true } : { notificationIds }),
        },
        dispatch
      );
    } catch (error) {
      console.error("Failed to mark as read:", error);
    }
  };
};

export const registerDeviceToken = (token) => {
  return async (dispatch) => {
    try {
      const response = await apiFetch(
        `${BASE_URL}${API_ENDPOINTS.NOTIFICATIONS_DEVICE_TOKEN}`,
        {
          method: "POST",
          headers: getAuthHeaders(),
          body: JSON.stringify({ token, device: navigator.userAgent }),
        },
        dispatch
      );
      if (response.ok) {
        dispatch({ type: NotificationActionConst.FCM_TOKEN_REGISTERED, token });
      } else {
        const body = await response.json().catch(() => ({}));
        console.error("[FCM] registerDeviceToken failed:", response.status, body);
      }
    } catch (error) {
      console.error("Failed to register device token:", error);
    }
  };
};

export const addForegroundNotification = (notification) => ({
  type: NotificationActionConst.ADD_FOREGROUND_NOTIFICATION,
  notification,
});
